var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"},on:{"contextmenu":function($event){$event.preventDefault();}}},[(_vm.displaySystem)?[_c('router-view')]:_vm._e(),(!_vm.showCookieNotice && !_vm.isNativeApp && _vm.canDisplayCookies)?_c('cookie-notice',{on:{"cookies-accepted":_vm.handleCookiesAccepted,"cookies-rejected":_vm.handleCookiesRejected}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }